import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { animateMenuItemHover } from "./animations/mobile-animations";

interface MobileNavigationProps {
  onLinkClick: () => void;
}

const MobileNavigation = ({ onLinkClick }: MobileNavigationProps) => {
  const location = useLocation();

  // Memoize menu items
  const menuItems = useMemo(
    () => [
      { name: "Home", path: "/" },
      { name: "Products", path: "/products" },
      { name: "Location", path: "/locations" },
      { name: "About", path: "/about" },
      // { name: "Blog", path: "/blog" },
      { name: "Contact", path: "/contact" },
    ],
    []
  );

  // Add hover animations to menu items
  useEffect(() => {
    const menuElements = document.querySelectorAll(".mobile-menu-link");
    const cleanupFunctions: (() => void)[] = [];

    menuElements.forEach((element) => {
      const cleanup = animateMenuItemHover(element as HTMLElement);
      if (cleanup) cleanupFunctions.push(cleanup);
    });

    return () => {
      cleanupFunctions.forEach((cleanup) => cleanup());
    };
  }, []);

  return (
    <nav
      className="flex flex-col h-full justify-center"
      role="navigation"
      aria-label="Mobile navigation"
    >
      <ul className="space-y-6 text-center">
        {menuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== "/" && location.pathname.startsWith(item.path));

          return (
            <li
              key={item.name}
              className="menu-item"
              style={{
                opacity: 0,
                transform: "translateY(20px)",
              }}
            >
              <Link
                to={item.path}
                className={`mobile-menu-link text-2xl font-medium transition-colors duration-300 ${
                  isActive
                    ? "text-cannabis-green-300"
                    : "text-white hover:text-cannabis-green-300"
                }`}
                onClick={onLinkClick}
                aria-current={isActive ? "page" : undefined}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default React.memo(MobileNavigation);
